import type { Props as _ButtonProps } from '@studio/design-system/button';
import { Button as _Button } from '@studio/design-system/button';
import type { T_Optional } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ButtonBoxProps } from './types.js';

type ButtonProps = _ButtonProps &
  T_Optional<{
    label: ReactElement | string;
  }>;

/** `<ButtonBox>` component. */
export const ButtonBox = ({ children, className, ...props }: ButtonBoxProps): ReactElement => (
  <div className={twMerge('flex items-center gap-12', className)} {...props}>
    {children}
  </div>
);

ButtonBox.Button = function Button({
  children,
  label,
  size = 'lg',
  ...props
}: ButtonProps): ReactElement {
  return (
    <_Button size={size} {...props}>
      {label}
      {children}
    </_Button>
  );
};

ButtonBox.Cancel = function Cancel({
  label = 'Cancel',
  variant = 'secondary',
  ...props
}: ButtonProps): ReactElement {
  return <ButtonBox.Button {...{ label, variant, ...props }} />;
};

ButtonBox.Save = function Save({ label = 'Save Changes', ...props }: ButtonProps): ReactElement {
  return <ButtonBox.Button label={label} {...props} />;
};
